import { CarrierAccessorialRequestData } from './carrier-accessorial-request-data';
import { LoadAccessorialDetailData } from './load-accessorial-detail-data';

export interface CarrierAccessorialRequestByLoadData {
  loadAccessorials: LoadAccessorialDetailData[];
  carrierAccessorialRequests: CarrierAccessorialRequestData[];
}
